import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Size Table',
  name: 'sizeTable',
  type: 'object',
  fields: [
    defineField({
      title: 'Make',
      name: 'make',
      type: 'string',
    }),
    defineField({
      title: 'Table',
      name: 'table',
      type: 'table',
    }),
    defineField({
      title: 'Description',
      name: 'description',
      type: 'text',
    }),
  ],
})